import { postData } from "../helpers/postData";
import { messageTimer } from "./timer";
import { getConstants } from "./constants";
import { openModal } from "../modal";

const { freeLessonModal } = getConstants();

if (freeLessonModal) {
  const testUrl = window.location.href.includes("/test/");
  const freeLessonStorage = JSON.parse(localStorage.getItem("freeLesson"));
  const freeLessonStatus = JSON.parse(localStorage.getItem("freeLessonStatus"));

  let { action, data } = createData(freeLessonModal);

  if (freeLessonStatus?.status) {
    if (freeLessonStorage?.timer === 0 && !testUrl) {
      openModalAfterReload(freeLessonModal, freeLessonStorage);
    }

    if (freeLessonStorage?.timer > 0) {
      const freeLessonStorage = JSON.parse(localStorage.getItem("freeLesson"));
      messageTimer(freeLessonStorage?.timer, freeLessonModal);
      setContent(
        freeLessonStorage.title,
        freeLessonStorage.text,
        freeLessonStorage.url
      );
    }
  } else {
    if (!testUrl) {
      sendAgain(action, data, freeLessonModal);
    }
  }
}

function openModalAfterReload(modal, storage) {
  openModal(modal);
  setContent(storage.title, storage.text, storage.url);
}

export function sendAgain(action, data, modal) {
  postData(action, data).then((res) => {
    if (res.status) {
      const title = res.title;
      const url = res.redirect_url;
      const desc = res.text;
      let time = res.time;

      localStorage.setItem(
        "freeLesson",
        JSON.stringify({
          click: data.number_click,
          text: desc,
          title: title,
          url: url,
          time: time,
          timer: time,
        })
      );
      localStorage.setItem(
        "freeLessonStatus",
        JSON.stringify({
          status: res.status,
        })
      );
      messageTimer(time, modal);
      setContent(title, desc, url);
    } else {
      localStorage.setItem(
        "freeLessonStatus",
        JSON.stringify({
          status: res.status,
        })
      );
    }
  });
}

function setContent(title, desc, url) {
  const { btnSignUp, lessonTitle, lessonDesc } = getConstants();
  btnSignUp.setAttribute("data-url", url);
  lessonTitle.innerHTML = title;
  if (desc) {
    lessonDesc.innerHTML = desc;
  }
}

export function createData(modal) {
  const action = modal.dataset.route;
  const locale = document.documentElement.getAttribute("lang");
  const freeLessonStorage = JSON.parse(localStorage.getItem("freeLesson"));

  let click = 1;

  freeLessonStorage?.click ? (click = freeLessonStorage.click) : click;
  let data = {
    locale,
    number_click: click,
  };

  return { action, data };
}
